import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Card,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import { AssignmentReturned as AssignmentReturnedIcon } from '@material-ui/icons';

import { FetchError } from '../../../common/api/api';
import CardTitle from '../../../common/card/CardTitle';
import TaskStatusLabel from '../../../common/TaskStatusLabel';
import { useFindDocumentChangeOrders } from '../Document.hook';
import { FileDto } from '../Document.interface';

export interface DocumentChangeOrderReferenceCardProps {
  document: FileDto;
  version?: number;
  onError?: (error: FetchError) => void;
}

const DocumentChangeOrderReferenceCard: React.FC<
  DocumentChangeOrderReferenceCardProps
> = props => {
  const { document, version, onError } = props;
  const history = useHistory();
  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;
  const { changeOrders, isLoading, error, findChangeOrders } =
    useFindDocumentChangeOrders(document.id);

  useEffect(() => {
    findChangeOrders(version ? { version } : undefined);
  }, [version, findChangeOrders]);

  useEffect(() => {
    if (error) {
      onErrorRef.current?.(error);
    }
  }, [error]);

  return (
    <Card>
      <CardTitle>
        <AssignmentReturnedIcon />
        Change Order References
      </CardTitle>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={3} padding='none'>
                  <LinearProgress />
                </TableCell>
              </TableRow>
            )}
            {changeOrders?.map(changeOrder => (
              <TableRow
                hover
                key={changeOrder.id}
                onClick={() => {
                  history.push(
                    `/portal/change-order/task/${changeOrder.task.id}`
                  );
                }}
              >
                <TableCell>CO-{changeOrder.id}</TableCell>
                <TableCell>{changeOrder.name}</TableCell>
                <TableCell>
                  <TaskStatusLabel task={changeOrder.task} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default DocumentChangeOrderReferenceCard;
